import React from 'react';


function PostJobs(props) {
    return (
    
        <div className="page-wrapper">          
            Post Jobs       
        </div>
    
    );
  }

export default PostJobs